import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

// Curated set of icons that make sense for form fields
export const FIELD_ICONS = [
  'Mail', 'Phone', 'User', 'Lock', 'Calendar', 'Clock', 'MapPin', 'Globe',
  'Search', 'Link', 'Hash', 'DollarSign', 'CreditCard', 'Building', 'Briefcase',
  'MessageSquare', 'FileText', 'Image', 'Camera', 'Key', 'Star', 'Heart',
  'Tag', 'Flag', 'Truck', 'Package', 'ShoppingCart', 'Home', 'Car',
  'Plane', 'Book', 'Pencil', 'AlertCircle', 'Info', 'CheckCircle', 'Zap',
  'UserCheck', 'AtSign', 'Percent', 'BarChart', 'Activity', 'Shield',
];

const IconPickerInline = ({ value, onChange }) => {
  const [search, setSearch] = useState('');
  const filtered = FIELD_ICONS?.filter(name =>
    name?.toLowerCase()?.includes(search?.toLowerCase())
  );
  return (
    <div className="space-y-2">
      <input
        type="text"
        value={search}
        onChange={e => setSearch(e?.target?.value)}
        placeholder="Search icons…"
        className="w-full text-xs border border-input rounded-md px-2.5 py-1.5 bg-background focus:outline-none focus:ring-2 focus:ring-primary"
      />
      <div className="grid grid-cols-6 gap-1 max-h-36 overflow-y-auto pr-0.5">
        {filtered?.map(name => (
          <button
            key={name}
            type="button"
            title={name}
            onClick={() => onChange(name)}
            className={`flex items-center justify-center w-8 h-8 rounded-md transition-colors ${
              value === name
                ? 'bg-primary/15 text-primary border border-primary/40'
                : 'hover:bg-muted text-muted-foreground hover:text-foreground border border-transparent'
            }`}
          >
            <Icon name={name} size={15} />
          </button>
        ))}
        {filtered?.length === 0 && (
          <p className="col-span-6 text-xs text-muted-foreground text-center py-2">No icons found</p>
        )}
      </div>
    </div>
  );
};

export default IconPickerInline;
